const en = {
  // Navigation
  navigation: {
    home: "Home",
    tracking: "Tracking",
    search: "Search",
    login: "myMSC",
    language: "Language"
  },
  
  // Menu items
  menu: {
    services: "Our Services",
    solutions: "Solutions",
    industries: "Industries",
    ebusiness: "eBusiness",
    sustainability: "Sustainability",
    aboutUs: "About Us",
    schedules: "Schedules",
    contact: "Contact Us",
    faq: "FAQ",
    tracking: "Tracking",
    blog: "Blog",
    certificates: "Certificates",
    login: "Login",
    getQuote: "Get a Quote"
  },
  
  // Hero section
  hero: {
    leaderIn: "OCEAN CROWN",
    shippingLogistics: "MULTILINK ENTERPRISE LTD",
    trackingTab: "TRACKING",
    schedulesTab: "SCHEDULES",
    contactsTab: "CONTACTS",
    containerBol: "Container / Bill of Lading Number",
    bookingNumber: "Booking Number",
    searchPlaceholder: "Search our services and solutions...",
    searchButton: "Search",
    title: "Global Shipping & Logistics Solutions",
    subtitle: "Connecting businesses across continents with reliable, efficient shipping & logistics services tailored to your needs.",
    primaryButton: "Contact Us",
    secondaryButton: "Our Services"
  },
  
  // Example component
  example: {
    title: "Using Translations Across Components",
    text: "This text is coming from the translation system. Each component can use the translation hook to display content in the selected language."
  },
  
  // Services Component
  services: {
    pageTitle: "Our Solutions",
    pageSubtitle: "Comprehensive shipping & logistics services tailored to meet your global transportation needs.",
    sectionTitle: "Our Services",
    sectionDescription: "Ocean Crown delivers comprehensive shipping & logistics services designed to optimize your supply chain and enhance your business performance.",
    learnMore: "Learn More",
    contactUs: "Request a Customized Solution",
    solutionsTitle: "Our Solutions",
    caseStudiesTitle: "Case Studies",
    
    ocean: {
      title: "Ocean Freight",
      description: "Comprehensive ocean freight solutions for all your shipping needs.",
      fullDescription: "Ocean Crown provides comprehensive ocean freight solutions tailored to your specific shipping requirements. Our global network ensures reliable and efficient transportation of your cargo across international waters.",
      feature1: "FCL (Full Container Load) shipping",
      feature2: "LCL (Less than Container Load) options",
      feature3: "Specialized equipment for oversized cargo",
      feature4: "Temperature-controlled containers",
      feature5: "Real-time tracking and monitoring",
      caseStudy1: {
        name: "Global Manufacturer",
        description: "Reduced shipping costs by 25% through optimized container utilization and route planning."
      },
      caseStudy2: {
        name: "Agricultural Exporter",
        description: "Implemented temperature-controlled shipping solutions, reducing spoilage by 98%."
      }
    },
    
    air: {
      title: "Air Freight",
      description: "Fast and reliable air freight services worldwide.",
      fullDescription: "Our air freight services provide rapid transportation solutions for time-sensitive cargo. With partnerships with major airlines, we ensure your shipments reach their destination quickly and safely.",
      feature1: "Express air freight services",
      feature2: "Charter flight options",
      feature3: "Door-to-door delivery",
      feature4: "Customs clearance assistance",
      feature5: "Real-time shipment tracking",
      caseStudy1: {
        name: "Electronics Manufacturer",
        description: "Delivered critical components to production facilities within 24 hours, preventing production delays."
      },
      caseStudy2: {
        name: "Pharmaceutical Company",
        description: "Managed the transportation of temperature-sensitive vaccines to 15 countries within 48 hours."
      }
    },
    
    inland: {
      title: "Inland Transportation",
      description: "Efficient inland transportation for your cargo.",
      fullDescription: "Our inland transportation services provide reliable and efficient movement of goods within countries and regions. We offer a comprehensive range of options to meet your specific needs.",
      feature1: "Road transportation",
      feature2: "Rail freight services",
      feature3: "Intermodal solutions",
      feature4: "Last-mile delivery",
      feature5: "Route optimization",
      caseStudy1: {
        name: "Retail Chain",
        description: "Implemented a hub-and-spoke distribution model, reducing delivery times by 40%."
      },
      caseStudy2: {
        name: "Construction Company",
        description: "Coordinated the delivery of heavy equipment to remote construction sites with 100% on-time delivery."
      }
    },
    
    warehousing: {
      title: "Warehousing & Distribution",
      description: "Secure and efficient warehousing and distribution solutions.",
      fullDescription: "Our warehousing and distribution services provide secure storage and efficient handling of your goods. We offer state-of-the-art facilities and advanced inventory management systems.",
      feature1: "Short and long-term storage",
      feature2: "Inventory management",
      feature3: "Order fulfillment",
      feature4: "Cross-docking services",
      feature5: "Value-added services",
      caseStudy1: {
        name: "E-commerce Platform",
        description: "Implemented automated order fulfillment system, reducing processing time by 60%."
      },
      caseStudy2: {
        name: "Consumer Goods Company",
        description: "Optimized warehouse layout and operations, increasing storage capacity by 35%."
      }
    },
    
    import: {
      title: "Import & Export",
      description: "Comprehensive import and export services for global trade.",
      fullDescription: "Our import and export services facilitate smooth international trade operations. We handle all aspects of the process, from documentation to customs clearance.",
      feature1: "Documentation preparation",
      feature2: "Customs clearance",
      feature3: "Trade compliance",
      feature4: "Export licensing",
      feature5: "Import regulations",
      caseStudy1: {
        name: "International Trader",
        description: "Streamlined import/export processes, reducing clearance time by 50%."
      },
      caseStudy2: {
        name: "Manufacturing Company",
        description: "Implemented comprehensive trade compliance program, eliminating regulatory issues."
      }
    },
    
    customs: {
      title: "Customs Clearance",
      description: "Expert customs clearance services to ensure smooth operations.",
      fullDescription: "Our customs clearance services ensure smooth and compliant movement of goods across borders. We handle all aspects of customs procedures and documentation.",
      feature1: "Import/export documentation",
      feature2: "Customs compliance consulting",
      feature3: "Duties and taxes management",
      feature4: "Trade agreement optimization",
      feature5: "Regulatory compliance",
      caseStudy1: {
        name: "Global Importer",
        description: "Reduced customs clearance time by 40% through optimized documentation processes."
      },
      caseStudy2: {
        name: "Export Company",
        description: "Implemented automated compliance checks, eliminating customs delays."
      }
    },
    
    global: {
      title: "Global Logistics",
      description: "End-to-end supply chain solutions tailored to your business needs and global requirements.",
      feature1: "Supply chain consulting",
      feature2: "International shipping expertise",
      feature3: "Multi-modal transportation"
    },
    
    documentation: {
      title: "Documentation Services",
      description: "Expert handling of all shipping documentation to ensure compliance and smooth operations.",
      feature1: "Bills of lading preparation",
      feature2: "Certificate of origin management",
      feature3: "Electronic documentation"
    },
    
    featured: {
      title: "Ocean Crown Integrated Solutions",
      description: "Our integrated logistics platform combines multiple services into a seamless supply chain solution, offering visibility, efficiency, and reliability.",
      item1: {
        title: "Supply Chain Visibility",
        description: "Real-time tracking and monitoring of your shipments with detailed status updates and exception alerts."
      },
      item2: {
        title: "Performance Analytics",
        description: "Comprehensive reporting and analytics to identify optimization opportunities in your supply chain."
      }
    }
  },
  
  // Stats Component
  stats: {
    title: "Global Reach, Local Expertise",
    description: "With a robust global network and deep local knowledge, we connect businesses across continents.",
    years: "Years of Experience",
    countries: "Countries Served",
    clients: "Active Clients",
    shipments: "Annual Shipments"
  },
  
  // Industries Component
  industries: {
    title: "Industries We Serve",
    description: "Specialized solutions for diverse business sectors, each with unique supply chain requirements.",
    automotive: {
      title: "Automotive",
      description: "Just-in-time logistics for automotive manufacturers and suppliers."
    },
    retail: {
      title: "Retail & Consumer",
      description: "Omnichannel fulfillment solutions for retailers and consumer goods companies."
    },
    pharma: {
      title: "Healthcare & Pharma",
      description: "Temperature-controlled and compliant logistics for the healthcare industry."
    },
    manufacturing: {
      title: "Manufacturing",
      description: "Streamlined logistics for manufacturing supply chains and production lines."
    },
    energy: {
      title: "Energy & Resources",
      description: "Specialized services for the energy sector and resource industries."
    },
    tech: {
      title: "Technology",
      description: "Fast, secure logistics for high-value technology products and components."
    }
  },
  
  // About Us Component
  aboutUs: {
    title: "About Ocean Crown",
    subtitle: "Your trusted logistics partner since 2012, connecting businesses across continents.",
    ourStory: {
      title: "Our Story",
      paragraph1: "Ocean Crown Multi-Links Enterprises Ltd was established in 2012 in Lagos, Nigeria, with a vision to revolutionize the logistics and shipping industry in West Africa through exceptional service delivery and operational excellence.",
      paragraph2: "Over the years, we have expanded our services and geographical reach, forming Global Ocean Crown Oil & Transport Ltd in 2018 to specialize in oil sector logistics and transportation services, enhancing our capabilities in Nigeria's energy market.",
      paragraph3: "Today, we are recognized as a leading logistics provider in Nigeria, offering comprehensive shipping, clearing, forwarding, and transportation services to clients across various industries."
    }
  },
  
  // Footer
  footer: {
    logoAlt: "Ocean Crown Logo",
    about: {
      title: "About Ocean Crown",
      description: "Ocean Crown delivers comprehensive shipping & logistics services designed to optimize your supply chain and enhance your business performance."
    },
    social: {
      facebook: "Visit our Facebook page",
      instagram: "Follow us on Instagram",
      twitter: "Follow us on X/Twitter"
    },
    quickLinks: "Quick Links",
    contactUs: "Contact Us",
    contact: {
      address: "67 Payne Crescent, Apapa, Lagos, Nigeria",
      phone1: "+234 805 340 8828",
      phone2: "+234 907 356 0121",
      email: "operations@ocmultilink.com",
      whatsapp: "WhatsApp",
      customerCare: "(Customer Care)"
    },
    subscribe: {
      title: "Subscribe to Our Newsletter",
      placeholder: "Your email address",
      button: "Subscribe",
      description: "Stay updated with the latest industry news and company updates."
    },
    copyright: "OCEAN CROWN MULTILINKS ENTERPRISES LTD. All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    sitemap: "Sitemap"
  },
  
  // Contact Component
  contact: {
    title: "Contact Us",
    subtitle: "Get in touch with our team of logistics experts. We're here to help you with all your shipping and transportation needs.",
    info: {
      title: "Contact Information",
      address: {
        title: "Address",
        text: "29 Payne Crescent, Apapa, Lagos, Nigeria"
      },
      phone: {
        title: "Phone",
        text: "+234 123 456 7890"
      },
      email: {
        title: "Email",
        text: "info@oceancrown.com"
      }
    },
    form: {
      title: "Send Us a Message",
      name: "Your Name",
      email: "Your Email",
      phone: "Your Phone",
      subject: "Subject",
      message: "Your Message",
      submit: "Send Message",
      success: "Thank you for your message. We'll get back to you soon!"
    }
  },
  
  // CTA Component
  cta: {
    title: "Ready to Optimize Your Shipping?",
    description: "Contact our team for a consultation or explore our FAQ to learn more about our services.",
    primaryButton: "Contact Us",
    secondaryButton: "Learn More"
  },
  
  // Testimonials
  testimonials: {
    title: "What Our Clients Say",
    client1: {
      text: "Ocean Crown has been our shipping partner for over 3 years. Their expertise and reliability have been crucial to our business growth. We've never experienced delays with their service.",
      name: "John Smithson",
      role: "Logistics Manager, Global Electronics"
    },
    client2: {
      text: "The attention to detail and personalized service from Ocean Crown is outstanding. Their team always goes above and beyond to ensure our shipments arrive safely and on time.",
      name: "Maria Rodriguez",
      role: "Import Director, Fresh Produce Inc."
    },
    client3: {
      text: "Transitioning to Ocean Crown was the best decision for our export operations. Their transparent pricing and efficient documentation process have saved us both time and money.",
      name: "Ahmed Hassan",
      role: "CEO, Hassan Trading Co."
    }
  }
};

export default en; 